import { mapActions } from 'vuex';
import VueFeedback from '@ui-common/vue-feedback';
import messages from './complaints-technical-error-lang.json';
export default {
	i18n: { messages },
	components: { VueFeedback },
	mounted() {
		document.querySelector('.link').addEventListener('click', () => this.setTechnicalError(false));
	},
	methods: {
		...mapActions('complaints', ['setTechnicalError'])
	}
};
